@if (userDetails$ | async; as user) {
<mat-accordion>
  <mat-expansion-panel class="py-1">
    <mat-expansion-panel-header>
      <mat-panel-title class="font-normal text-base"
        >Email Notifications</mat-panel-title
      >
    </mat-expansion-panel-header>
    <form [formGroup]="emailPreferences" (ngSubmit)="onSubmitEmailPrefs()">
      <div class="description-container flex flex-col">
        <ul>
          <li class="flex flex-row justify-between items-center">
            <mat-label>
              <span> Emails</span>
            </mat-label>
            <span>
              <mat-slide-toggle
                labelPosition="before"
                color="primary"
                formControlName="emails"
                (change)="toggleAllEmails()"
              ></mat-slide-toggle>
            </span>
          </li>
        </ul>
        <ul formGroupName="preferences">
          <mat-divider color="primary"></mat-divider>
          <li class="flex flex-row justify-between items-center">
            <span> Bids</span>
            <span>
              <mat-slide-toggle
                formControlName="bids"
                labelPosition="before"
                color="primary"
              ></mat-slide-toggle>
            </span>
          </li>
          <li class="flex flex-row justify-between items-center">
            <span>Offers</span>
            <span>
              <mat-slide-toggle
                formControlName="offers"
                labelPosition="before"
                color="primary"
              ></mat-slide-toggle>
            </span>
          </li>
          <mat-divider color="primary"></mat-divider>
          <li class="pt-3">
            <mat-form-field class="w-full">
              <mat-label>Preferred Commodities </mat-label>
              <mat-select multiple formControlName="commodities">
                @for (comm of commodities(); track comm._id ) {
                <mat-option [value]="comm.commodity">{{
                  comm.commodity
                }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </li>
          <mat-divider color="primary"></mat-divider>
          <li class="flex flex-col justify-between items-start">
            <div class="w-full flex flex-row justify-between items-center">
              <span>Negotiations</span>
              <mat-slide-toggle
                labelPosition="before"
                color="primary"
                formControlName="negotiations"
              ></mat-slide-toggle>
            </div>
            <span class="text-xs pt-3 ml-2"
              >New negotiations, counters, accept, and decline email
              notifications</span
            >
          </li>
          <mat-divider color="primary"></mat-divider>
          <li class="flex flex-row justify-between items-center">
            <span>Contracts</span>
            <span>
              <mat-slide-toggle
                formControlName="contracts"
                labelPosition="before"
                color="primary"
              ></mat-slide-toggle>
            </span>
          </li>
          <mat-divider color="primary"></mat-divider>
          <li class="flex flex-row justify-between items-center">
            <span>Trades</span>
            <span>
              <mat-slide-toggle
                formControlName="trades"
                labelPosition="before"
                color="primary"
              ></mat-slide-toggle>
            </span>
          </li>
        </ul>
        <div class="flex flex-row justify-end mt-2 px-4">
          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="emailPreferences.pristine"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  </mat-expansion-panel>
  <mat-expansion-panel class="py-1">
    <mat-expansion-panel-header>
      <mat-panel-title class="font-normal text-base"
        >Push Notifications</mat-panel-title
      >
    </mat-expansion-panel-header>
    <form
      [formGroup]="pushNotifications"
      (ngSubmit)="onSubmitNotificationPrefs()"
    >
      <div>
        <ul>
          <li class="flex flex-row justify-between items-center">
            <span>Bids</span>
            <span>
              <mat-slide-toggle
                labelPosition="before"
                color="primary"
                formControlName="bids"
              ></mat-slide-toggle>
            </span>
          </li>
          <li class="flex flex-row justify-between items-center">
            <span>Offers</span>
            <span>
              <mat-slide-toggle
                labelPosition="before"
                color="primary"
                formControlName="offers"
              ></mat-slide-toggle>
            </span>
          </li>
          <li class="flex flex-row justify-between items-center">
            <span>Negotiations</span>
            <span>
              <mat-slide-toggle
                labelPosition="before"
                formControlName="negotiations"
                color="primary"
              ></mat-slide-toggle>
            </span>
          </li>
          <li class="flex flex-row justify-between items-center">
            <span>Trades</span>
            <span>
              <mat-slide-toggle
                labelPosition="before"
                color="primary"
                formControlName="trades"
              ></mat-slide-toggle>
            </span>
          </li>
          <li class="flex flex-row justify-between items-center">
            <span>Contracts</span>
            <span>
              <mat-slide-toggle
                labelPosition="before"
                formControlName="contracts"
                color="primary"
              ></mat-slide-toggle>
            </span>
          </li>
          <li class="pt-3">
            <mat-form-field class="w-full">
              <mat-label>Preferred Commodities </mat-label>
              <mat-select multiple formControlName="commodities">
                @for (comm of commodities(); track comm.commodity) {
                <mat-option [value]="comm.commodity">{{
                  comm.commodity
                }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </li>
          <li class="pt-3">
            <mat-form-field class="w-full">
              <mat-label>Preferred Commodities </mat-label>
              <mat-select multiple formControlName="topics">
                @for (topic of topicValues; track topic.value) {
                <mat-option [value]="topic.value">{{ topic.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </li>
        </ul>
        <div class="flex flex-row justify-end mt-2 px-4">
          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="pushNotifications.pristine"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  </mat-expansion-panel>
</mat-accordion>
}
